var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bmui-cell_arrow1" }, [
    _c("p", { staticClass: "bmui-cell_arrow1-title" }, [
      _vm._v(_vm._s(_vm.title || "TITLE")),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isNeed,
              expression: "isNeed"
            }
          ],
          staticClass: "bmui-cell_arrow1-isNeed"
        },
        [_vm._v("*")]
      )
    ]),
    _vm._v(" "),
    _vm.$slots.default
      ? _c(
          "div",
          { staticClass: "bmui-cell_arrow1-content" },
          [_vm._t("default")],
          2
        )
      : _c("p", { staticClass: "bmui-cell_arrow1-content" }, [
          _vm._v(_vm._s(_vm.content))
        ]),
    _vm._v(" "),
    _c("i", { staticClass: "bmui-cell_arrow1-icon" })
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c81258de", { render: render, staticRenderFns: staticRenderFns })
  }
}